<template>
    <div>
        <div class="order-receipt-header">
            <h1>{{ $t('order.receipt_title') }}</h1>
        </div>
        <div class="order-receipt-content">
            <v-icon size="150"> mdi-receipt </v-icon><br/>
            <h3>{{ $t('order.no_reciept') }}</h3>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters} from "vuex";

export default {
    name: 'Home',
    data() {
        return {
            form: {},
            loading: false
        };
    },
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components:{},
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {},
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {},
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted () {}
}
</script>

<style lang="scss" scoped>
.order-receipt {
    background-color: #f9fafb;

    &-header {
        padding-top: 20px;
        background-color: #ffffff;
        height: 150px;
        text-align: center;
        align-content: center;
        align-items: center;
        justify-content: center;
        justify-self: center;
        min-width: 100%;
        font-size: 26px;
        font-weight: bold;
    }

    &-content {
        padding: 40px;
        background-color: #f9fafb;
        min-height: 400px;
        text-align: center;
        align-content: center;
        align-items: center;
        justify-content: center;
        justify-self: center;
    }
}
</style>